import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Apiurl from "../environment/Apiurl";

const AddLabManagement = () => {
  const [addData, setAddData] = useState({
    lab_report_id: "",
    lab_source: "",
    lab_name: "",
    lab_address: "",
    report_date: "",
    report_status: "",
    patient_id: "",
    referred_by: "",
    test_type: "",
    test_code: "",
    sample_code: "",
    sample_type: "",
    sample_collected_date: "",
    sample_status: "",
    result_summary: "",
    result_values: "",
    normal_range: "",
    remarks: "",
    charge_amount: "",
    payment_status: "",
    report_file: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // Full form validation
  const validateForm = () => {
    const newErrors = {};
    if (!addData.lab_report_id.trim())
      newErrors.lab_report_id = "* Lab Report ID is required";
    if (!addData.lab_source.trim())
      newErrors.lab_source = "* Lab Source is required";
    if (!addData.lab_name.trim()) newErrors.lab_name = "* Lab Name is required";
    if (!addData.lab_address.trim())
      newErrors.lab_address = "* Lab Address is required";
    if (!addData.report_date)
      newErrors.report_date = "* Report Date is required";
    if (!addData.report_status)
      newErrors.report_status = "* Report Status is required";
    if (!addData.patient_id.trim())
      newErrors.patient_id = "* Patient ID is required";
    if (!addData.referred_by.trim())
      newErrors.referred_by = "* Referred By is required";

    if (!addData.test_type.trim())
      newErrors.test_type = "* Test Type is required";
    if (!addData.test_code.trim())
      newErrors.test_code = "* Test Code is required";
    if (!addData.sample_code.trim())
      newErrors.sample_code = "* Sample Code is required";
    if (!addData.sample_type.trim())
      newErrors.sample_type = "* Sample Type is required";
    if (!addData.sample_collected_date)
      newErrors.sample_collected_date = "* Collected Date is required";
    if (!addData.sample_status)
      newErrors.sample_status = "* Sample Status is required";
    if (!addData.result_summary.trim())
      newErrors.result_summary = "* Result Summary is required";
    if (!addData.result_values.trim())
      newErrors.result_values = "* Result Values are required";
    if (!addData.normal_range.trim())
      newErrors.normal_range = "* Normal Range is required";
    if (!addData.charge_amount.toString().trim())
      newErrors.charge_amount = "* Charge Amount is required";
    if (!addData.payment_status)
      newErrors.payment_status = "* Payment Status is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCancel = () => {
    navigate("/lab-management");
  };

  const handleSubmit = async () => {
    try {
      const formData = {
        lab_report_id: addData.lab_report_id,
        lab_source: addData.lab_source,
        lab_name: addData.lab_name,
        lab_address: addData.lab_address,
        report_date: addData.report_date,
        report_status: addData.report_status,
        patient_id: addData.patient_id,
        referred_by: addData.referred_by,
        test_type: addData.test_type,
        test_code: addData.test_code,
        sample_code: addData.sample_code,
        sample_type: addData.sample_type,
        sample_collected_date: addData.sample_collected_date,
        sample_status: addData.sample_status,
        result_summary: addData.result_summary,
        result_values: addData.result_values,
        normal_range: addData.normal_range,
        remarks: addData.remarks,
        charge_amount: addData.charge_amount,
        payment_status: addData.payment_status,
        report_file: addData.report_file,
      };
      const response = await axios.post(`${Apiurl}/lab_management`, formData);
      setAddData(response.data);
      navigate("/lab-management");
    } catch (error) {
      console.error("error", error.message);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && !["application/pdf"].includes(file.type)) {
      setErrors({
        ...errors,
        report_file: "Only PDF files are allowed",
      });
      return;
    }
    setAddData({ ...addData, report_file: file ? file.name : "" });
    setErrors({ ...errors, report_file: "" });
  };

    //   Top to move
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="p-2">
      <div className="card card-body">
        {/* Patient & Report Details */}
        <h5 className="mb-2 fw-bold text-center">Patient & Report Details</h5>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <label>Lab Report ID</label>
            <input
              type="text"
              className="form-control"
              value={addData.lab_report_id}
              onChange={(e) =>
                setAddData({ ...addData, lab_report_id: e.target.value })
              }
            />
            {errors.lab_report_id && (
              <span className="text-danger mt-5">{errors.lab_report_id}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-2">
            <label>Lab Source</label>
            <select
              className="form-control"
              value={addData.lab_source}
              onChange={(e) =>
                setAddData({ ...addData, lab_source: e.target.value })
              }
            >
              <option value="">Select Lab Source</option>
              <option value="Internal">Internal</option>
              <option value="External">External</option>
            </select>
            {errors.lab_source && (
              <span className="text-danger">{errors.lab_source}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Lab Name</label>
            <input
              type="text"
              className="form-control"
              value={addData.lab_name}
              onChange={(e) =>
                setAddData({ ...addData, lab_name: e.target.value })
              }
            />
            {errors.lab_name && (
              <span className="text-danger">{errors.lab_name}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-2">
            <label>Lab Address</label>
            <input
              type="text"
              className="form-control"
              value={addData.lab_address}
              onChange={(e) =>
                setAddData({ ...addData, lab_address: e.target.value })
              }
            />
            {errors.lab_name && (
              <span className="text-danger">{errors.lab_address}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-2">
            <label>Patient ID</label>
            <input
              type="text"
              className="form-control"
              value={addData.patient_id}
              onChange={(e) =>
                setAddData({ ...addData, patient_id: e.target.value })
              }
            />
            {errors.patient_id && (
              <span className="text-danger">{errors.patient_id}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Referred By</label>
            <input
              type="text"
              className="form-control"
              value={addData.referred_by}
              onChange={(e) =>
                setAddData({ ...addData, referred_by: e.target.value })
              }
            />
            {errors.referred_by && (
              <span className="text-danger">{errors.referred_by}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Report Date</label>
            <input
              type="date"
              className="form-control"
              value={addData.report_date}
              onChange={(e) =>
                setAddData({ ...addData, report_date: e.target.value })
              }
            />
            {errors.report_date && (
              <span className="text-danger">{errors.report_date}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Report Status</label>
            <select
              className="form-control"
              value={addData.report_status}
              onChange={(e) =>
                setAddData({ ...addData, report_status: e.target.value })
              }
            >
              <option value="">Select</option>
              <option value="Pending">Pending</option>
              <option value="Processing">Processing</option>
              <option value="Completed">Completed</option>
            </select>
            {errors.report_status && (
              <span className="text-danger">{errors.report_status}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Report File</label>
            <input
              type="file"
              className="form-control"
              accept="application/pdf"
              onChange={handleFileChange}
            />
            {errors.report_file && (
              <span className="text-danger">{errors.report_file}</span>
            )}
            {addData.report_file && (
              <p className="mt-1">
                Current File: <strong>{addData.report_file}</strong>
              </p>
            )}
          </div>
        </div>

        {/* Test Information */}
        <h5 className="mt-3 mb-2 fw-bold text-center">Test Information</h5>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <label>Test Type</label>
            <input
              type="text"
              className="form-control"
              value={addData.test_type}
              onChange={(e) =>
                setAddData({ ...addData, test_type: e.target.value })
              }
            />
            {errors.test_type && (
              <span className="text-danger">{errors.test_type}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Test Code</label>
            <input
              type="text"
              className="form-control"
              value={addData.test_code}
              onChange={(e) =>
                setAddData({ ...addData, test_code: e.target.value })
              }
            />
            {errors.test_code && (
              <span className="text-danger">{errors.test_code}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Sample Type</label>
            <input
              type="text"
              className="form-control"
              value={addData.sample_type}
              onChange={(e) =>
                setAddData({ ...addData, sample_type: e.target.value })
              }
            />
            {errors.sample_type && (
              <span className="text-danger">{errors.sample_type}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Sample Code</label>
            <input
              type="text"
              className="form-control"
              value={addData.sample_code}
              onChange={(e) =>
                setAddData({ ...addData, sample_code: e.target.value })
              }
            />
            {errors.sample_code && (
              <span className="text-danger">{errors.sample_code}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Sample Collected Date</label>
            <input
              type="date"
              className="form-control"
              value={addData.sample_collected_date}
              onChange={(e) =>
                setAddData({
                  ...addData,
                  sample_collected_date: e.target.value,
                })
              }
            />
            {errors.sample_collected_date && (
              <span className="text-danger">
                {errors.sample_collected_date}
              </span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Sample Status</label>
            <select
              className="form-control"
              value={addData.sample_status}
              onChange={(e) =>
                setAddData({ ...addData, sample_status: e.target.value })
              }
            >
              <option value="">Select</option>
              <option value="Collected">Collected</option>
              <option value="Processed">Processed</option>
              <option value="Rejected">Rejected</option>
            </select>
            {errors.sample_status && (
              <span className="text-danger">{errors.sample_status}</span>
            )}
          </div>
        </div>

        {/* Result Information */}
        <h5 className="mt-3 mb-2 fw-bold text-center">Result Information</h5>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <label>Result Values</label>
            <input
              type="text"
              className="form-control"
              value={addData.result_values}
              onChange={(e) =>
                setAddData({ ...addData, result_values: e.target.value })
              }
            />
            {errors.result_values && (
              <span className="text-danger">{errors.result_values}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Normal Range</label>
            <input
              type="text"
              className="form-control"
              value={addData.normal_range}
              onChange={(e) =>
                setAddData({ ...addData, normal_range: e.target.value })
              }
            />
            {errors.normal_range && (
              <span className="text-danger">{errors.normal_range}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Result Summary</label>
            <textarea
              type="text"
              rows={2}
              className="form-control"
              value={addData.result_summary}
              onChange={(e) =>
                setAddData({ ...addData, result_summary: e.target.value })
              }
            />
            {errors.result_summary && (
              <span className="text-danger">{errors.result_summary}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Remarks</label>
            <textarea
              type="text"
              rows={2}
              className="form-control"
              value={addData.remarks}
              onChange={(e) =>
                setAddData({ ...addData, remarks: e.target.value })
              }
            />
          </div>
        </div>

        {/* Payment Information */}
        <h5 className="mt-3 mb-2 fw-bold text-center">Payment Information</h5>
        <div className="row">
          <div className="col-md-4 col-lg-3">
            <label>Charge Amount</label>
            <input
              type="number"
              className="form-control"
              value={addData.charge_amount}
              min="0"
              onChange={(e) =>
                setAddData({ ...addData, charge_amount: e.target.value })
              }
            />
            {errors.charge_amount && (
              <span className="text-danger">{errors.charge_amount}</span>
            )}
          </div>

          <div className="col-md-4 col-lg-3">
            <label>Payment Status</label>
            <select
              className="form-control"
              value={addData.payment_status}
              onChange={(e) =>
                setAddData({ ...addData, payment_status: e.target.value })
              }
            >
              <option value="">Select</option>
              <option value="Paid">Paid</option>
              <option value="Pending">Pending</option>
            </select>
            {errors.payment_status && (
              <span className="text-danger">{errors.payment_status}</span>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-between mt-4">
          <button className="btn btn-success btn-sm" onClick={handleCancel}>
            Cancel
          </button>
          <button className="btn btn-danger btn-sm" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddLabManagement;
